/**
 * Sidebar top brand row with a hidden multi-tap easter egg.
 */

import { cn } from '@/lib/utils';
import { BRAND } from '@/config/brand';
import { BrandLogo } from '@/components/brand';

import { useSidebarLogoEasterEgg } from './useSidebarLogoEasterEgg';

export function SidebarBrandBar({ collapsed }: { collapsed: boolean }) {
  const { onBrandBarPointerDown } = useSidebarLogoEasterEgg();

  return (
    <div
      role="presentation"
      onPointerDown={onBrandBarPointerDown}
      className={cn(
        'flex h-16 select-none items-center border-b',
        collapsed ? 'justify-center px-3' : 'px-6',
      )}
    >
      {collapsed ? (
        <span
          role="img"
          aria-label={BRAND.name}
          className="font-display text-2xl font-semibold leading-none text-primary"
        >
          N
        </span>
      ) : (
        <BrandLogo className="h-9" />
      )}
    </div>
  );
}
